import { queryOptions } from '@tanstack/react-query'
import { sort } from 'remeda'
import { mainnet } from 'viem/chains'
import { z } from 'zod'

import { SavingsRateChartData } from './types'
import { sparkDataApiUrl } from '@/config/consts'
import { stusdsAddress } from '@/config/contracts-generated'
import { percentageAboveOneSchema } from '@/domain/common/validation'
import { dateSchema } from '@/utils/schemas'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function stusdsSavingsRateQueryOptions() {
  return queryOptions<SavingsRateChartData>({
    queryKey: ['stusds-rate'],
    queryFn: async () => {
      // @todo: replace with stUSDS address from abi cli when available
      const response = await fetch(`${sparkDataApiUrl}/tokens/${stusdsAddress[mainnet.id]}/historic/`)
      if (!response.ok) {
        throw new Error(`Failed to fetch savings rate data: ${response.statusText}`)
      }
      const result = await response.json()
      const { data } = stusdsRateDataResponseSchema.parse(result)

      const sortedApy = sort(data, (a, b) => a.date.getTime() - b.date.getTime())
      const apyWithCutoff = sortedApy.filter((item) => item.date > new Date('2025-10-12'))

      return {
        apy: apyWithCutoff,
      }
    },
  })
}

const stusdsRateDataResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(
    z.object({
      date: dateSchema,
      rate: percentageAboveOneSchema,
    }),
  ),
})
